var map = {
	"./CAP.png": 91,
	"./CHAPKA.png": 92,
	"./LAZARUS_SPIRE.png": 93,
	"./LEATHER_BOOTS.png": 94,
	"./LIGHT_PLATE_BOOTS.png": 95,
	"./QUILTED.png": 96,
	"./RABBIT.png": 97,
	"./RONDACHE.png": 98,
	"./SASH.png": 99,
	"./STAFF.png": 100,
	"./SUN_HELM.png": 101,
	"./SUN_SHIRT.png": 102
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90;


//////////////////
// WEBPACK FOOTER
// ./src/images/items ^\.\/.*\.png$
// module id = 90
// module chunks = 48